import PriceTrendOverTimeChart from '../charts/PriceTrendOverTimeChart';

interface TrendExplorerTabProps {
  t: (key: string) => string;
}
const TrendExplorerTab = ({ t }: TrendExplorerTabProps) => {
  return (
    <div className="tab trend-explorer-tab px-2 pt-8 md:px-8 md:pt-12 lg:pt-14">
      <PriceTrendOverTimeChart t={t} />
    </div>
  );
};

export default TrendExplorerTab;
